// extracted by mini-css-extract-plugin
export default {"playerArchive":"PlayerArchive_playerArchive__u8NZa","name":"PlayerArchive_name__2-eI4","inline":"PlayerArchive_inline__YUvEq","birthday":"PlayerArchive_birthday__MPuvM"};